<div class="modal-header">
    <h3 class="modal-title">Import {{type}}</h3>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div [ngBusy]="busy"></div>
    <ngb-alert *ngIf="errorMessage.hasError()" [dismissible]="true" [type]="'danger'"  (close)="errorMessage.reset()">
        <div><strong>{{errorMessage.title}}</strong></div>
        <div>{{errorMessage.message}}</div>
    </ngb-alert>
    <form [formGroup]="form" *ngIf="fileNameList.length == 0 && !importReport">
        <h5>Select a {{type}} file to import</h5>
        <input class="form-control mb-2" style="padding-bottom: 36px;" type="file" id="content"
            (change)="onFileChange($event)" #fileInput>

    </form>

    <ng-container *ngIf="fileNameList.length > 0 && !importReport">
        <h5>Select the files to import</h5>
        <table class="table table-hover table-outline table-striped">
            <thead>
                <th style="width: 20px">
                    <div class="custom-control custom-checkbox mb-0">
                        <input class="custom-control-input" name="selectAll-import" id="selectAll-import"
                            type="checkbox" tooltip="Select all" checked="true"
                            (change)="fillExportListModal($event, fileNameCheckedList, fileNameList);">
                        <label class="custom-control-label" for="selectAll-import"></label>
                    </div>
                </th>
                <th>Filename</th>
            </thead>
            <tbody>
                <tr *ngFor="let file of fileNameList; let i=index;">
                    <td>
                        <div class="custom-control custom-checkbox mb-0">
                            <input type="checkbox" class="custom-control-input" name="selectedItem-{{file}}"
                                id="selectedItem-{{file}}" type="checkbox"
                                [checked]="fileNameCheckedList.indexOf(file) >= 0"
                                (change)="handleExportListModal(file,fileNameCheckedList)" type="checkbox"
                                [value]="file">
                            <label class="custom-control-label" for="selectedItem-{{file}}"></label>
                        </div>
                    </td>
                    <td>{{file}}</td>
                </tr>
            </tbody>
        </table>
    </ng-container>
    <ng-container *ngIf="importReport">
        <h5>Import report</h5>
        <table class="table table-sm table-outline table-hover">
            <thead>
                <th>Filename</th>
                <th>Message</th>
                <th style="width: 50px;">Status</th>
                <th style="width:20px;"></th>
            </thead>
            <tbody>
                <ng-container *ngFor="let element of importReportElements">
                    <tr>
                        <td>{{element.name}}</td>
                        <td>{{element.message}}</td>
                        <td>
                            <span
                                [ngClass]="{'badge-success': element.status == 'OK','badge-warning': element.status == 'WARNING','badge-danger': element.status == 'KO'}"
                                class="badge badge-pill">{{element.status}}</span>
                        </td>
                        <td style="width:20px;">
                            <a *ngIf="element.subElements && element.subElements != null && element.subElements.length > 0"
                                (click)="element.showSubElements = !element.showSubElements">
                                <i *ngIf="!element.showSubElements" class="mio vam mr-2">keyboard_arrow_right</i>
                                <i *ngIf="element.showSubElements" class="mio vam mr-2">keyboard_arrow_down</i>
                            </a>
                        </td>
                    </tr>
                    <tr *ngIf="element.showSubElements">
                        <td [attr.colspan]="4" class="pl-2">
                            <table class="table table-sm table-outline table-hover">
                                <thead>
                                    <th>Filename</th>
                                    <th>Message</th>
                                    <th style="width: 50px;">Status</th>
                                    <th style="width:20px;"></th>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let subElement of element.subElements">
                                        <tr>
                                            <td>{{subElement.name}}</td>
                                            <td>{{subElement.message}}</td>
                                            <td>
                                                <span
                                                    [ngClass]="{'badge-success': subElement.status == 'OK','badge-warning': subElement.status == 'WARNING','badge-danger': subElement.status == 'KO'}"
                                                    class="badge badge-pill">{{element.status}}</span>
                                            </td>
                                            <td style="width:20px;">
                                                <a *ngIf="subElement.subElements && subElement.subElements != null && subElement.subElements.length > 0"
                                                    (click)="subElement.showSubElements = !subElement.showSubElements">
                                                    <i *ngIf="!subElement.showSubElements"
                                                        class="mio vam mr-2">keyboard_arrow_right</i>
                                                    <i *ngIf="subElement.showSubElements"
                                                        class="mio vam mr-2">keyboard_arrow_down</i>
                                                </a>
                                            </td>
                                        </tr>
                                        <tr *ngIf="subElement.showSubElements">
                                            <td [attr.colspan]="4" class="pl-2">
                                                <table class="table table-sm table-outline table-hover">
                                                    <thead>
                                                        <th>Filename</th>
                                                        <th>Message</th>
                                                        <th style="width: 50px;">Status</th>
                                                        <th style="width:20px;"></th>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container
                                                            *ngFor="let subSubElement of subElement.subElements">
                                                            <tr>
                                                                <td>{{subSubElement.name}}</td>
                                                                <td>{{subSubElement.message}}</td>
                                                                <td>
                                                                    <span
                                                                        [ngClass]="{'badge-success': subSubElement.status == 'OK','badge-warning': subSubElement.status == 'WARNING','badge-danger': subSubElement.status == 'KO'}"
                                                                        class="badge badge-pill">{{element.status}}</span>
                                                                </td>
                                                                <td style="width:20px;">
                                                                    <a *ngIf="subSubElement.subElements && subSubElement.subElements != null && subSubElement.subElements.length > 0"
                                                                        (click)="subSubElement.showSubElements = !subSubElement.showSubElements">
                                                                        <i *ngIf="!subSubElement.showSubElements"
                                                                            class="mio vam mr-2">keyboard_arrow_right</i>
                                                                        <i *ngIf="subSubElement.showSubElements"
                                                                            class="mio vam mr-2">keyboard_arrow_down</i>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                            <tr *ngIf="subSubElement.showSubElements">
                                                                <td [attr.colspan]="4" class="pl-4">
                                                                    <table
                                                                        class="table table-sm table-outline table-hover">
                                                                        <thead>
                                                                            <th>Filename</th>
                                                                            <th>Message</th>
                                                                            <th style="width: 50px;">Status</th>
                                                                            <th style="width:20px;"></th>
                                                                        </thead>
                                                                        <tbody>
                                                                            <ng-container
                                                                                *ngFor="let subSubSubElement of subSubElement.subElements">
                                                                                <tr>
                                                                                    <td>{{subSubSubElement.name}}</td>
                                                                                    <td>{{subSubSubElement.message}}
                                                                                    </td>
                                                                                    <td>
                                                                                        <span
                                                                                            [ngClass]="{'badge-success': subSubSubElement.status == 'OK','badge-warning': subSubSubElement.status == 'WARNING','badge-danger': subSubElement.status == 'KO'}"
                                                                                            class="badge badge-pill">{{element.status}}</span>
                                                                                    </td>
                                                                                    <td style="width:20px;">
                                                                                        <a *ngIf="subSubSubElement.subElements && subSubSubElement.subElements != null && subSubSubElement.subElements.length > 0"
                                                                                            (click)="subSubSubElement.showSubElements = !subSubSubElement.showSubElements"><i
                                                                                                *ngIf="!subSubSubElement.showSubElements"
                                                                                                class="mio vam mr-2">keyboard_arrow_right</i>
                                                                                            <i *ngIf="subSubSubElement.showSubElements"
                                                                                                class="mio vam mr-2">keyboard_arrow_down</i>
                                                                                        </a>
                                                                                    </td>
                                                                                </tr>
                                                                            </ng-container>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>

    </ng-container>

</div>
<div class="modal-footer d-flex justify-content-between">
    <button class="btn btn-light" (click)="activeModal.close()" *ngIf="!importCompleted">Cancel</button>
    <button class="btn btn-primary" type="button" (click)="submitFile()" *ngIf="fileNameList.length == 0 && !importReport && !importCompleted"
        ngbAutofocus>
        Import</button>
    <button class="btn btn-primary" type="button" (click)="submitZip()" *ngIf="fileNameList.length > 0 && !importReport && !importCompleted"
        ngbAutofocus>
        Import</button>
    <button class="btn btn-light" (click)="activeModal.close()" *ngIf="importCompleted">Cancel</button>
    <button class="btn btn-primary" type="button" (click)="activeModal.close()" *ngIf="importCompleted" ngbAutofocus>
        Close</button>
</div>